export const USCenter = {
    lat: 38.6,
    lng: -95.1,
};
